import CustomBtn from "../../components/fragments/CustomBtn";
import NotificationCard from "../../components/fragments/NotificationCard";
import POSHeader from "components/POSHeader";
import React, { useEffect, useState } from "react";
import { kitchenHandler } from "../../redux/handlers";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";
const DELIVERY_OPTIONS_MAP = new Map([
  ["DINE_IN", 1],
  ["TAKEAWAY", 2],
  ["DELIVERY", 3],
]);
export default function Notification() {
  const notification = useSelector((state) => state.kitchen.notification);
  const [productSearchKeyword, setProductSearchKeyword] = useState("");
  const dispatch = useDispatch();
  const { businessSlug } = useParams();
  const branchSellingId = localStorage.getItem("branchPOSSelling");
  const [notiData, setNotiData] = useState([]);

  useEffect(() => {
    async function fetchAndUpdateNotification() {
      const data = {
        branch_pos_selling_id: Number(branchSellingId),
      };
      await dispatch(
        kitchenHandler.notification(businessSlug, branchSellingId)
      );
      await dispatch(kitchenHandler.updateMessageToRead(businessSlug, data));
      await dispatch(
        kitchenHandler.getTotalUnreadCount(businessSlug, branchSellingId)
      );
    }
    fetchAndUpdateNotification();
  }, [branchSellingId, businessSlug, dispatch]);
  useEffect(() => {
    const updateFormat = notification?.map((item) => {
      const date = moment(item.updated_at);
      const orderDate = date.format("DD/MM/YYYY");
      const orderTime = date.format("HH:MM");
      return {
        id: item.id,
        orderType: item.status_kitchen,
        orderNo: item.order.code,
        placeType: DELIVERY_OPTIONS_MAP.get(item.order.order_type),
        info: "",
        orderItem: item.orderItem.product.name,
        date: orderDate,
        time: orderTime,
      };
    });
    setNotiData(updateFormat);
  }, [notification]);

  return (
    <div>
      <POSHeader isSearch={true} setFilterText={setProductSearchKeyword} />
      <div className="flex flex-col pt-[min(1.72vw,22px)] px-[min(3.13vw,40px)]">
        <div className="text-18 font-[500] text-[#333333]">การแจ้งเตือน</div>
        <CustomBtn
          onClick={() => {}}
          className={`leading-[0.8] mt-[min(2.44vw,25px)] w-fit min-w-[min(11.13vw,114px)] text-14 text-white !font-[500] min-h-[min(3.32vw,34px)] rounded-[min(0.78vw,8px)] btn-main-active`}
          btntxt={"แจ้งเตือนในร้าน"}
        />
        <div className="w-full border-[min(0.20vw,2px)] border-[#D9D9D9] mt-[min(2.05vw,21px)] rounded-[min(1.56vw,16px)]">
          {notiData.map((data, i) => {
            return (
              <NotificationCard
                key={`noti-card-${i}`}
                notiData={data}
                isLast={i === notiData.length - 1}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
